export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-yahoo-18418195cfc35dec8ad43af2a18d8285.svg";